const NotificationsHeader = ({
    allCount,
    newCount,
}) => {
    return (
        <div className="notifications-header sticky top-0">
            <div
                data-testid="header-notifications"
                className={`
                    notifications-header-bar bg-white
                    flex justify-center items-center
                    p-4
                    gap-4
                    cursor-default
                    text-[#313334]
                    text-sm
                `}
            >
                <div>All ({allCount})</div>
                <div className="text-is2-black-20">New ({newCount})</div>
                <div className="text-is2-black-20">Viewed ({allCount - newCount})</div>
            </div>
            <div className="bg-[#EFEFF0] h-[6px]"></div>
        </div>
    );
}

export default NotificationsHeader;
